import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/permission.js'
import '@/assets/style/public.css'
import Vant from 'vant'
import 'vant/lib/index.less'
import VueClipboard from 'vue-clipboard2'

Vue.config.productionTip = false
Vue.use(VueClipboard)
Vue.use(Vant)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
